var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoryBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: 100,
    height: 100,
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    className: "currentLayer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#ef638c",
    d: "m125 30l0 0 0 0 -93.1 33.2 14.2 123.1 78.9 43.7 0 0 0 0 78.9-43.7 14.2-123.1 -93.1-33.2zM125 30 125 30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#e72564",
    d: "m125 30l0 22.2 0-0.1 0 101.3 0 0 0 76.6 0 0 78.9-43.7 14.2-123.1 -93.1-33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    fill: "#fff",
    d: "m166.54 98.73c0.79-33.27-15.12-49.7-42.82-49.7 -27.71 0-43.23 17.07-43.23 42.66 0 44.57 53.05 45.43 53.05 69.74 0 6.82-2.95 10.88-9.43 10.88 -8.45 0-11.79-5.98-11.4-22.61 -3.32 0-29.88 0-33.2 0 -2.55 41.16 19.65 50.54 44.99 50.54 24.56 0 43.81-12.37 43.81-39.24 0-47.77-53.83-46.49-53.83-70.16 0-9.6 6.29-10.88 10.02-10.88 3.93 0 11 1.7 10.41 19.62 6.33-0.17 28.47-0.77 31.63-0.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    fill: "#fff",
    d: "m185.96 52.04l23.13-1.97 0 34.94 -11.63-10.52 -13.96 10.52 2.46-32.97z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryBook);
export default __webpack_public_path__ + "static/media/storyBook.ec779d7e96e70ca2d11eaf29c160c2e8.svg";
export { ForwardRef as ReactComponent };